// Seizer List
export const SeizerListBase = 'legal-institute-management/seizer-list'
export const seizerListApi = SeizerListBase + '/list'
export const seizerStoreApi = SeizerListBase + '/store'
export const seizerUpdateApi = SeizerListBase + '/update'
export const seizerStatusApi = SeizerListBase + '/toggle-status'
// Tagging Social Worker
// export const TaggingSocialWorkerBase = 'legal-institute-management/tagging-social-worker'
export const SocialWorkerListApi = 'legal-institute-management/tagging-social-worker/list'
export const childDataForCourtApi2 = 'legal-institute-management/tagging-social-worker/info-by-child-number'
export const SocialWorkerStoreApi = 'legal-institute-management/tagging-social-worker/store'
export const SocialWorkerUpdateApi = 'legal-institute-management/tagging-social-worker/update'
export const SocialWorkerToggleStatusApi = 'legal-institute-management/tagging-social-worker/toggle-status'
// Case File Management
// export const CaseFileManagementBase = 'legal-institute-management/case-file-management'
export const caseFileManagementListApi = 'legal-institute-management/case-file-management/list'
export const childDataForCourtApi3 = 'legal-institute-management/case-file-management/info-by-child-number'
export const caseFileManagementStoreApi = 'legal-institute-management/case-file-management/store'
export const caseFileManagementUpdateApi = 'legal-institute-management/case-file-management/update'
export const caseFileManagementToggleStatusApi = 'legal-institute-management/case-file-management/toggle-status'
// Case File Management
// export const CaseFileManagementBase = 'legal-institute-management/case-file-management'
export const CaseFileManagementBase = 'configuration/add-class'
// Court Calendar
export const courtCalendarListApi = 'legal-institute-management/court-calendar/list'
export const courtCalendarDetailsApi = 'legal-institute-management/court-calendar/details'
export const childDataForCourtApi = 'legal-institute-management/court-calendar/info-by-child-number'
export const courtCalenderStoreApi = 'legal-institute-management/court-calendar/store'
export const courtCalenderUpdateApi = 'legal-institute-management/court-calendar/update'
export const courtCalendarStatusApi = 'legal-institute-management/court-calendar/toggle-status'
// Court Attendance
// export const Attendance = 'legal-institute-management/court-attendance'
export const courtAttendanceListApi = 'legal-institute-management/court-attendance/list'
export const courtAttendanceStoreApi = 'legal-institute-management/court-attendance/store'
export const courtAttendanceUpdateApi = 'legal-institute-management/court-attendance/update'
export const courtAttendanceStatusApi = 'legal-institute-management/court-attendance/toggle-status'
// Court Attendance
// Release Order
export const releaseOrderListApi = 'legal-institute-management/release-order/list'
export const releaseOrderDetailsApi = 'legal-institute-management/release-order/details'
export const approvedApi = 'legal-institute-management/release-order/approved'
export const releaseOrderStoreApi = 'legal-institute-management/release-order/store'
export const releaseOrderUpdateApi = 'legal-institute-management/release-order/update'
// E-Notifications
// export const CourtCalendarBase = 'legal-institute-management/court-attendance'
export const eNotificationBase = 'configuration/e-notification'
export const eNotificationBaseList = eNotificationBase + '/list'
export const eNotificationBaseStore = eNotificationBase + '/store'
export const eNotificationBaseShow = eNotificationBase + '/show'
export const eNotificationBaseUpdate = eNotificationBase + '/update'
export const eNotificationBaseStatus = eNotificationBase + '/toggle-status'
export const eNotificationBaseDestroy = eNotificationBase + '/destroy'

// Nothi api
export const nothi = 'nothi/'
export const pendingNothiReleaseOrderApi = nothi + 'release-order-sent-nothi'
export const reSentNothiReleaseOrderApi = nothi + 'release-order-re-sent-nothi'
